<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
>

</script>
<template>
  <!-- The Modal -->
  <div
      id="createModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Create Client"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Title</label>
                      <validation-provider
                          #default="{ errors }"
                          name="title"
                          rules="required"
                      >
                        <v-select
                            v-model="createdClient.title"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="titles"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="first_name">First Name </label>
                      <validation-provider
                          #default="{ errors }"
                          name="First Name"
                          rules="required"
                      >
                        <b-form-input
                            id="first_name"
                            v-model="createdClient.first_name"
                            name="first_name"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="last_name">Last Name</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Last Name"
                          rules="required"
                      >
                        <b-form-input
                            id="last_name"
                            v-model="createdClient.last_name"
                            name="last_name"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="phone_number">Phone</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Phone"
                          rules="required"
                      >
                        <b-form-input
                            id="phone_number"
                            v-model="createdClient.phone_number"
                            type="number"
                            name="phone_number"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="last_name">EID</label>
                      <validation-provider
                          #default="{ errors }"
                          name="EID"
                          rules="required"
                      >
                        <b-form-input
                            id="eid_number"
                            v-model="createdClient.eid_number"
                            type="number"
                            name="eid_number"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="email">Email</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Email"
                          rules="required|email"
                      >
                        <b-form-input
                            id="email"
                            v-model="createdClient.email"
                            type="email"
                            name="email"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="front_image">Eid Front Image</label>
                      <validation-provider
                          #default="{ errors }"
                          name="image"
                          rules=""
                      >
                        <vue-dropzone
                            id="front_image"
                            ref="createFrontRef"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            name="image"
                            :options="dropzoneOptions"
                            @vdropzone-max-files-exceeded="resetDropzone()"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="image">Eid Back Image</label>
                      <validation-provider
                          #default="{ errors }"
                          name="image"
                          rules=""
                      >
                        <vue-dropzone
                            id="front_image"
                            ref="createBackRef"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            name="image"
                            :options="dropzoneOptions"
                            @vdropzone-max-files-exceeded="resetDropzone()"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import {codeMultiple, codeBasic} from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import clientService from '@/services/clientService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Spinner from '@/shared/loader/Spinner'

export default {
  components: {
    BCardCode,
    Spinner,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['services'],
  data() {
    return {
      createdClient: {
        title: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        eid_number: '',
        email: '',
        eid_front_image: '',
        eid_back_image: '',
      },
      titles: ['Mr.', 'Ms.'],
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        maxFiles: 1,
      },
      edited_service: {
        name: '',
        description: ''
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.createdClient.eid_front_image = this.$refs.createFrontRef.getAcceptedFiles()[0]
              this.createdClient.eid_back_image = this.$refs.createBackRef.getAcceptedFiles()[0]
              clientService.post(this.createdClient)
                  .then(response => {
                    if (response && response.status === 200) {
                      this.$emit('refresh', 'true')
                      this.createdClient = {
                        title: '',
                        first_name: '',
                        last_name: '',
                        phone_number: '',
                        eid_number: '',
                        email: '',
                        eid_front_image: '',
                        eid_back_image: '',
                      }
                      this.$refs.createFrontRef.removeAllFiles()
                      this.$refs.createBackRef.removeAllFiles()

                      $('#createModal').modal('hide')

                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Client Is Created Successfully !`,
                        },
                      })
                    }

                  })
            }
          })
    },
    resetDropzone() {
      this.$refs.createRef.removeAllFiles()

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
